export default __webpack_public_path__ + "static/media/photo--sm--134.7b067b13.jpg";